import React, { Component } from 'react'
import Datetime from 'react-datetime'

import './datetime.scss'

// Components
import LabelWrapper from '../labelWrapper'
import Text from '../text'

class DateTime extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }

    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.renderInput = this.renderInput.bind(this)
  }

  onChange (e) {
    // console.log('Datetime onChange triggered!', e)
    if (this.props.onChange !== null) {
      this.props.onChange(e)
    }
  }

  onBlur (e) {
    // console.log('Datetime onBlur triggered!', e)
    if (this.props.onBlur !== null) {
      this.props.onBlur(e)
    }
  }

  // getSizeClass () {
  //   switch (this.props.size) {
  //     case undefined:
  //     case null:
  //     case 'l':
  //       return 'size-large'
  //     case 'm':
  //       return 'size-medium'
  //     case 's':
  //       return 'size-small'
  //   }
  // }

  getSolidClass () {
    return ''
  }

  getBorderClass () {
    return ''
  }

  getStyle () {
    if (this.props.disabled) {
      // Disabled styling
    } else {
      return 'element-datetime ' + ' ' + this.getSolidClass() + ' ' + this.getBorderClass() + ' '
    }
  }

  renderInput (props, openCalendar, closeCalendar) {
    return (
      <Text {...props} onClick={openCalendar} onBlur={closeCalendar} size={this.props.size} />
    )
  }

  render () {
    const { value, inputProps, disabled, timeFormat, closeOnSelect, isValidDate, timeConstraints, labelText, helpText } = this.props
    let { className } = this.props

    const renderDatetime = () => {
      if (this.props.alignDatePickerRight) {
        className += ' align-rdt-right'
      }

      return (
        <Datetime
          className={className}
          value={value}
          inputProps={inputProps}
          onChange={this.onChange}
          onBlur={this.onBlur}
          disabled={disabled}

          isValidDate={isValidDate}
          dateFormat='DD-MM-YYYY'
          timeFormat={timeFormat}
          closeOnSelect={closeOnSelect}
          renderInput={this.renderInput}
          timeConstraints={timeConstraints}
        />
      )
    }

    const renderWrapper = (content) => {
      return (
        <LabelWrapper
          labelText={labelText}
          helpText={helpText}
        >
          {content}
        </LabelWrapper>
      )
    }

    return (
      <div className={this.getStyle()}>
        {this.props.labelText !== null ? renderWrapper(renderDatetime()) : renderDatetime()}
      </div>
    )
  }
}

DateTime.defaultProps = {
  size: 'l',
  style: 'default',
  labelText: null,
  helpText: null,
  value: null,
  onChange: null,
  onBlur: null,
  disabled: false,
  isValidDate: () => true,
  timeConstraints: null,
  alignDatePickerRight: false
}

export default DateTime



// WEBPACK FOOTER //
// ./src/app/shared/elements/datetime/index.js